import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=2fe830ce&scoped=true&"
import script from "./Work.vue?vue&type=script&lang=ts&"
export * from "./Work.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe830ce",
  null
  
)

export default component.exports